if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class Select extends HTMLElement {
      constructor() {
        super();
        /**
         * @type {HTMLFormElement | null}
         */
        this.form = this.querySelector('form');

        /**
         * @type {HTMLSelectElement}
         */
        this.selector = this.querySelector('select[name="country_code"]') || document.createElement('select');
        this.selector.addEventListener('change', this.onChangeHandler.bind(this));
      }

      onChangeHandler() {
        if (this.form) {
          this.form.submit();
        }
      }
    },
  );
}
